import * as React from "react";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { useEffect, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import ButtonCustom from "../ButtonCustom";
import useGetUserRelated from "../../hooks/store/useUserRelatedStore";
import { useNavigate } from "react-router";
import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
} from "@mui/icons-material";
import Grid from "@mui/material/Unstable_Grid2";
function not(a: readonly any[], b: readonly any[]) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a: readonly any[], b: readonly any[]) {
  return a.filter((value) => b.some((item) => item.id === value.id));
}

function union(a: readonly any[], b: readonly any[]) {
  return [...a, ...not(b, a)];
}

export default function SelectAllTransferList({
  chosen = [],
  choices = [],
  id,
}: any) {
  const theme = useTheme();
  const isScreenSM = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { updateUsersRelated } = useGetUserRelated();
  const [checked, setChecked] = useState<any[]>([]);
  const [left, setLeft] = useState<any>(choices);
  const [right, setRight] = useState<any>(chosen);
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: any) => () => {
    const currentIndex = checked.findIndex((item) => item.id === value.id);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  useEffect(() => {
    setLeft(choices);
    setRight(chosen);
  }, [choices, chosen]);
  const numberOfChecked = (items: any) => intersection(checked, items)?.length;

  const handleToggleAll = (items: any) => () => {
    if (numberOfChecked(items) === items?.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight([...right, ...leftChecked]);
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft([...left, ...rightChecked]);
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleUpdate = async () => {
    const data = {
      idUsersChosen: right.map((item: any) => item.id),
      idLoja: id,
    };
    await updateUsersRelated(data);
    navigate("/store-list");
  };

  const customList = (title: React.ReactNode, items: any) => (
    <Card
      sx={(theme) => ({
        ...(theme.palette.mode === "dark" && {
          backgroundColor: "rgb(37, 37, 38)",
        }),
      })}
    >
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items?.length && items?.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items?.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items?.length === 0}
            inputProps={{
              "aria-label": "all items selected",
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items?.length} selecionado`}
      />
      <Divider />
      <List
        sx={{
          height: 530,
          bgcolor: "background.paper",
          overflow: "auto",
        }}
        dense
        component="div"
        role="list"
      >
        {items?.map((value: any) => (
          <ListItem
            key={value?.id}
            role="listitem"
            button
            onClick={handleToggle(value)}
          >
            <ListItemIcon>
              <Checkbox
                checked={checked.some((item) => item?.id === value?.id)}
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": value?.name }}
              />
            </ListItemIcon>
            <ListItemText id={value?.name} primary={value?.name} />
          </ListItem>
        ))}
      </List>
    </Card>
  );

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid xs={12} sm={12} md={5.5} lg={5.5}>
          {customList("Não associados", left)}
        </Grid>
        <Grid
          container
          xs={12}
          sm={12}
          md={1}
          lg={1}
          direction="column"
          alignItems="center"
        >
          <Button
            sx={{ m: 1 }}
            variant="outlined"
            size="small"
            color="success"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected chosen"
          >
            {isScreenSM ? <ArrowDownward /> : <ArrowForward />}
          </Button>
          <Button
            sx={{ m: 1 }}
            variant="outlined"
            size="small"
            color="error"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected choices"
          >
            {isScreenSM ? <ArrowUpward /> : <ArrowBack />}
          </Button>
        </Grid>

        <Grid xs={12} sm={12} md={5.5} lg={5.5}>
          {customList("Associados", right)}
        </Grid>

        <Grid xs={12} md={12} lg={12} xl={12} sx={{ mt: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Button onClick={() => navigate(-1)}>Voltar</Button>
            <ButtonCustom text="Salvar" event={handleUpdate} />
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
